<template>
    <div>
        <base-title :subtitle="StringLanguage.marketingAutomation" :title="$route.params.id ? StringLanguage.editCampaign : StringLanguage.newCampaign" :link="'marketing'"/>

        <campaign :status="campaign.status" :action="false" :name="campaign.name" :icon="`far ${campaigntypes[campaign.alias].icon}`">
            {{ campaigntypes[campaign.alias].description ? campaigntypes[campaign.alias].description : campaign.description }}
        </campaign>

        <base-box class="setting-box" v-if="!$route.params.id">
            <p class="question">Dê um nome a sua campanha personalizada</p>
            <base-input v-model="campaign.name" :label="StringLanguage.campaignName" class="m_0"/>
        </base-box>

        <base-box class="setting-box">
            <p class="question">Configure o benefício oferecido</p>

            <div class="row coupon-config">
                <div :class="campaign.coupon.type != 74 && campaign.coupon.type != 76 ? 'col-lg-12' : 'col-lg-6'">
                    <base-select :title="'Tipo do benefício'" v-model="campaign.coupon.type">
                        <option :value="74">Desconto em R$</option>
                        <option :value="76">Desconto em %</option>
                        <option :value="84">Taxa grátis</option>
                        <option value="null">Não oferecer benefício</option>
                    </base-select>
                </div>
                <div v-if="campaign.coupon.type == 74 || campaign.coupon.type == 76" class="col-lg-6">
                    <base-input :label="'Valor do benefício'" v-model="campaign.coupon.value" :money-mask="{ precision: 2 }"/>
                </div>
                <div v-if="campaign.coupon.type > 70" class="col-lg-6">
                    <base-input :label="'Código do cupom'" v-model="campaign.coupon.code"  />
                </div>
                <div v-if="campaign.coupon.type > 70" class="col-lg-6">
                    <base-input :label="'Gasto minimo para uso'" v-model="campaign.coupon.minValue" :money-mask="StringLanguage.currencyConfigs" />
                </div>
            </div>
        </base-box>

        <base-box class="setting-box">
            <p class="question">Para quando quer agendar sua campanha?</p>
            <base-input v-model="campaign.date" :label="'Data de envio'" :type="'text'" :mask="'##/##/####'" @blur="checkPeriod" :masked="true" class="m_0"/>
        </base-box>

        <base-box class="setting-box">
            <p class="question">Em qual periodo deve ser enviado?</p>
            <div class="row">
                <div class="col-lg-6" v-if="!period.LUNCH.disable">
                    <base-radio :enabled="period.LUNCH.disable" :family="'period'" :label="StringLanguage.lunch" :option="'LUNCH'" v-model="campaign.run_at" />
                </div>
                <div class="col-lg-6">
                    <base-radio :enabled="period.DINNER.disable" :family="'period'" :label="StringLanguage.dinner" :option="'DINNER'" v-model="campaign.run_at" />
                </div>
            </div>
        </base-box>

        <!-- <base-box class="setting-box">
            <p class="question">Selecione os métodos que ela será enviada</p>
            <send-method :label="'SMS'" :isNew="true" :checked="campaign.send.sms.enabled" @setValue="value => campaign.send.sms.enabled = value" />
            <send-method :label="'Push'" :isNew="true" :checked="campaign.send.push.enabled" @setValue="value => campaign.send.push.enabled = value" />
            <send-method :label="'Email'" :isNew="true" :checked="campaign.send.email.enabled" @setValue="value => campaign.send.email.enabled = value" />
        </base-box> -->

        <base-box class="setting-box">
            <p class="question">Configure a mensagem que será enviada via SMS</p>
            <base-textarea :label="'Mensagem SMS'" :max="'150'" :rows="'3'" class="m_0" v-model="campaign.send.sms.template" />
            <div class="reset">
                <p @click="openPreview('sms')">{{StringLanguage.preview}}</p>
                <p>|</p>
                <p @click="setDefaultTemplate('sms')">{{StringLanguage.restoreDefault}}</p>
            </div>
        </base-box>

        <base-box class="setting-box">
            <p class="question">Configure a mensagem que será enviada via Push</p>
            <base-textarea :label="'Mensagem Push'" :max="'120'" :rows="'3'" class="m_0" v-model="campaign.send.push.template" />
            <div class="reset">
                <p @click="openPreview('push')">{{StringLanguage.preview}}</p>
                <p>|</p>
                <p @click="setDefaultTemplate('push')">{{StringLanguage.restoreDefault}}</p>
            </div>
        </base-box>

        <base-box class="setting-box">
            <p class="question">Configure a mensagem que será enviada via Email</p>
            <base-textarea :label="'Mensagem de Email'" :rows="'5'" class="m_0" v-model="campaign.send.email.template" />
            <div class="reset">
                <p @click="openPreview('email')">{{StringLanguage.preview}}</p>
                <p>|</p>
                <p @click="setDefaultTemplate('email')">{{StringLanguage.restoreDefault}}</p>
            </div>
        </base-box>

        <base-drawer :open="preview.open" :title="StringLanguage.previewMessage">
            <p class="preview-msg">{{preview.message}}</p>
        </base-drawer>

        <div class="text-right">
            <base-button @click="createUpdateCampaign" :text="StringLanguage.save"/>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/pt-br'
dayjs.locale('pt-br')
dayjs.extend(customParseFormat)
import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseInput from '@/components/Input'
import BaseSelect from '@/components/Select'
import BaseRadio from '@/components/Radio'
import BaseTextarea from '@/components/Textarea'
import BaseDrawer from '@/components/Drawer'

import Campaign from '@/containers/Marketing/Campaign'
import SendMethod from '@/containers/Marketing/SendMethod'

import MarketingAPI from '@/api/marketing'
import StoreAPI from '@/api/store'

import { mapState } from 'vuex'
import Gift, { TYPE } from "easyjs/lib/Schema/Gift"

export default {
    components: {
        BaseTitle,
        BaseButton,
        BaseBox,
        BaseInput,
        BaseSelect,
        BaseRadio,
        BaseTextarea,
        BaseDrawer,
        Campaign,
        SendMethod,
    },

    data() {
        return {
            templateStrings: {
                sms: "",
                push: "",
                email: "",
            },
            giftType: null,
            preview: {
                open: false,
                message: "",
                type: null
            },
            period: {
                LUNCH: {
                    disable: false,
                    limit: 10
                },
                DINNER: {
                    disable: false,
                    limit: 18
                }
            },
            campaign: {
                name: StringLanguage.customCampaign,
                alias: 'custom',
                description: StringLanguage.customCampaignDescription,
                run_at: 'LUNCH',
                coupon: {
                    type: 0
                },
                send: {
                    sms: {
                        enabled: false
                    },
                    push: {
                        enabled: false
                    },
                    email: {
                        enabled: false
                    }

                },
                status: 'WAITING'
            }
        }
    },

    created () {
        this.checkPeriod()
        this.setCampaign()
    },

    methods: {
        openPreview(type) {
            this.preview.type = type;
            this.preview.message = this.campaign.send[type].template;
            this.preview.open = !this.preview.open;
        },
        async setCampaign () {
            if (this.$route.params.id) {
                await MarketingAPI.campaign(this.$route.params.id).then(result => {
                    let campaign = result.getData({campaigns: [] }).campaigns[0]

                    this.removeParameter(campaign, '__typename')

                    if(['WAITING', 'SCHEDULED', 'PAUSED', ].indexOf(campaign.status) == -1) {
                        alert('Essa campanha está bloqueada para edição!').then((confirm) => {
                            this.$router.push({ name: 'marketing' });
                        })
                        return false;
                    }

                    campaign.date = this.convertData(campaign.date)
                    campaign.coupon.value = `${(+campaign.coupon.value).toFixed(2)}`
                    campaign.coupon.minValue = `${(+campaign.coupon.minValue).toFixed(2)}`
                    this.campaign = campaign
                    this.checkPeriod()
                    this.loadTemplateStrings(campaign.alias)
                })
            }
        },

        removeParameter (obj, parameter) {
            for (let prop in obj) {
                if (prop === parameter)
                    delete obj[prop]
                else if (typeof obj[prop] === 'object')
                    this.removeParameter(obj[prop], parameter)
            }
        },

        couponType (type, condition) {
            const gift = Gift.fromObject({type: type})
            return gift.typeIs(condition)
        },

        convertData (date) {
            if (!date) date = dayjs().format()
            date = date.split('T')[0]

            if (date.search('/') >= 0) {

                let datespl = date.split('/')
                return `${datespl[2]}-${datespl[1]}-${datespl[0]}`
            }

            let datespl = date.split('-')
            return `${datespl[2]}/${datespl[1]}/${datespl[0]}`
        },

        checkPeriod () {
            if (!this.campaign.date) {
                this.campaign.date = dayjs().format('DD/MM/YYYY')
            }

            let dateFormated = dayjs(this.campaign.date, 'DD/MM/YYYY')
            this.period.LUNCH.disable = false
            this.campaign.run_at = 'LUNCH'

            if(dayjs().isAfter(dateFormated)) {
                this.campaign.date = dayjs().format('DD/MM/YYYY')
                dateFormated = dayjs(this.campaign.date, 'DD/MM/YYYY')
            }

            StoreAPI.storeIsOpen(dateFormated.toDate().getTime()).then((response) => {

                if (dayjs().isSame(dateFormated, 'day') && dayjs().isSame(dateFormated, 'month') && dayjs().isSame(dateFormated, 'year')) {

                    if (dayjs().hour() > this.period.DINNER.limit) {
                        this.period.LUNCH.disable = false
                        this.campaign.date = dayjs(dateFormated).add(1, 'day').format('DD/MM/YYYY')
                        return true
                    }

                    if (dayjs().hour() > this.period.LUNCH.limit) {
                        this.period.LUNCH.disable = true
                        this.campaign.run_at = 'DINNER'
                        return true
                    }
                }
                let periods = response.getData({ working_time: { periods: [] }}).working_time.periods;
                for (let i in periods) {
                    let open = (Object.values(periods[i].days || {}).firstOrDefault({ open: "" }) ).open
                    let hour = (open || "").substring(0, 2)
                    if (this.period.DINNER.limit > hour) {
                        this.campaign.run_at = 'DINNER'
                    }
                }
            })
        },

        async createUpdateCampaign () {
            let campaign = JSON.parse(JSON.stringify(this.campaign))
            campaign.date = this.convertData(this.campaign.date)
            campaign.coupon.type *= 1;
            campaign.coupon.value *= 1;
            campaign.coupon.minValue *= 1;
            return MarketingAPI.addCampaign(campaign).then((response) => {
                if(response.getErrors([]).length > 0) {
                    return alert(StringLanguage.saveError);
                }
                return alert(StringLanguage.saveSuccess);
            })
        },
        async loadTemplateStrings(campaignType) {
            MarketingAPI.campaignTemplate(campaignType).then((response) => {
                this.templateStrings = response.getData({ campaignStrings: this.templateStrings }).campaignStrings;
                ['sms', 'push', 'email'].forEach((type) => {
                    if(!this.campaign.send[type].template) {
                        this.campaign.send[type].template = this.templateStrings[type]
                    }
                })
            });
        },
        setDefaultTemplate(type) {
            confirm(StringLanguage.confirmRestoreDefaultMessage, (response) => {
                if(response) {
                    this.campaign.send[type].template = this.templateStrings[type]
                }
            })
        }
    },

    computed: {
        ...mapState ({
            campaigntypes: state => state.marketing.campaigntypes
        })
    }
}
</script>

<style scoped>
    .setting-box{
        padding: 40px;
    }

    .question{
        font-size: 1.6em;
        font-weight: 300;
        color: #999;
        margin-bottom: 30px;
    }

    .reset {
        margin-top: 20px;
        font-size: 1.2em;
        text-transform: uppercase;
        color: var(--default);
        font-weight: 600;
        text-align: right;
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
    }

    .reset p:nth-child(2){
        margin: 0 15px;
    }

    .preview-msg{
        font-size: 1.4em;
        text-align: center;
        color: #999;
    }

    .coupon-config .col-lg-6{
        min-height: 68px;
    }
</style>